export interface IMarque {
  id?: number;
  marqueLib?: string;
}
export class Marque implements IMarque {
  constructor(public id?: number, public marqueLib?: string) {}
}
